import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchSlotCommand } from '@puppycad/cad-core';
import SlotPropertySection from '@/components/editor/property-manager/slot/SlotPropertySection.vue';

registerPropertyManagerSection({
  id: SketchSlotCommand.Straight,
  title: '槽口',
  order: 14,
  component: SlotPropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.slotPropertyVisible === true),
});
